import React from "react";
import { FormattedMessage } from "react-intl";
import { useFormikContext } from "formik";
import { Box, Button } from "@chakra-ui/react";
import { ArrowForwardIcon } from "@chakra-ui/icons";

export const NextButton = ({ section, onClick }) => {
  const { errors, touched } = useFormikContext();
  return (
    <Box textAlign="right">
      <Button
        data-testid={`next-button-${section}`}
        isDisabled={errors[section] || !touched[section]}
        variant="outline"
        colorScheme="gray"
        rightIcon={<ArrowForwardIcon />}
        onClick={onClick}
      >
        <FormattedMessage defaultMessage="Next" description="Button label" />
      </Button>
    </Box>
  );
};

export const UpdateEmailButton = ({ onClick, disabled }) => {
  return (
    <Button
      data-testid="update-email-button"
      isDisabled={disabled}
      colorScheme="blue"
      rightIcon={<ArrowForwardIcon />}
      onClick={onClick}
      w={180}
      minHeight="40px"
      height="auto"
      whiteSpace="normal"
    >
      <FormattedMessage defaultMessage="Update email" description="Button label" />
    </Button>
  );
};

export const VerifyEmailButton = ({ onClick, disabled }) => {
  return (
    <Button
      data-testid="verify-email-button"
      isDisabled={disabled}
      variant="outline"
      colorScheme="gray"
      rightIcon={<ArrowForwardIcon />}
      onClick={onClick}
      w={180}
    >
      <FormattedMessage defaultMessage="Verify email" description="Button label" />
    </Button>
  );
};
